<template>
  <el-container class="full-content" style="background-color:#27BE7D;">
    <el-main class="flex-col-center">
      <div class="login-center flex-row-start">
        <div class="login-left-bg flex-col-center">
          <div class="login-left-img">
            <img :src="$Image('sginInBG.png')" alt="">
          </div>
        </div>
        <div class="login-right">
          <div class="login-right-welcome">{{$t('Welcome to FamiKit')}}</div>
          <div class="login-box signUp-box">
            <div style="margin-top:13%;width:100%;" class="flex-col-center">
              <div class="loginInputBox">
                <el-input class="login-input flex-row-center" @focus="getFocus" :placeholder="$t('Email')" v-model="emailValue" tabindex="1">
                </el-input>
                <img class="email" :src="$Image('ico_eml.png')" alt="">
              </div>
              <div class="loginInputBox">
                <el-input @keyup.enter.native="onSignIn" class="login-input flex-row-center" style="margin-top:20px;" :placeholder="$t('Password')" :type="isShowPassword ?   'text' : 'password'" v-model="password" tabindex="2">
                </el-input>
                  <img class="password" :src="$Image('ico_psw.png')" alt="">
                  <img class="hide1" v-if="!isShowPassword" @click="onShowPassword" :src="$Image('ico_hide.png')" alt="">
                  <img class="hide2" v-if="isShowPassword" @click="onShowPassword" :src="$Image('ico_disp.png')" alt="">
              </div>
              <div style="width:100%;height:16px;color:#a94442;font-size:14px;margin-top:10px;text-align:center;" v-if="error">{{errorType}}</div>
              <div class="errorStyle" v-if="!error && onClickLongin" style="margin-top:10px;color:#434343;font-size:18px;">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </div>
          <el-button :disabled="isDisableLogin&&!error" class="normalBtn sign-btn" style="width:190px;height:46px;font-size:18px;" @click="onSignIn">{{$t('Sign in')}}
          </el-button>
          <div class="no-account">
            {{$t('No account?')}}
            <span @click="onRegister">{{$t('Register now')}}</span>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="login-footer flex-col-center">
      <span>{{$t('Copyright @ 2020, Famikit.com. All rights reserved.')}}</span>
    </el-footer>
  </el-container>
</template>
<script>
import JSEncrypt from 'jsencrypt'
import { setCookieArray, getCookieArray } from '../api/cookies.js'
import { mapState } from 'vuex'
import * as Mutations from '../../store/mutations'
// import OSS from 'ali-oss'
export default {
  name: 'Login',
  data () {
    return {
      emailValue: '',
      password: '',
      isShowPassword: false,
      error: false,
      errorType: '',
      cookiesList: [],
      showCookiesList: [],
      isDisableLogin: false,
      onClickLongin: false,
      showCookies: false,
      Networkdifference: false,
      userID: null
    }
  },
  computed: {
    ...mapState([
      'isLogined'
    ])
  },
  methods: {
    onShowPassword: function () {
      this.isShowPassword = !this.isShowPassword
    },
    getFocus () {
      if (this.cookiesList.length === 0) {
        const names = getCookieArray('name')
        if (names === null) {
          this.showCookiesList = []
        } else {
          var arrHaha = names.split(',')
          if (arrHaha.length > 5) {
            arrHaha = arrHaha.slice(arrHaha.length - 5, arrHaha.length)
          }
          arrHaha.map(n => {
            if (n !== '') {
              this.cookiesList.push({name: n})
            }
          })
        }
      }
      this.filterAccount(this.emailValue)
      this.showCookies = true
    },
    onPassword () {
      let Reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      if (this.emailValue === '') {
        this.error = true
        this.errorType = this.$t('Email cannot be blank.')
        this.showCookies = false
      } else if (!Reg.test(this.emailValue.trim())) {
        this.error = true
        this.errorType = this.$t('Please enter a valid email address')
      } else {
        this.error = false
      }
      if (this.password === '') {
        if (!this.error) {
          this.error = true
          this.errorType = this.$t('Password cannot be blank.')
        }
      } else {
        if (!this.error) {
          this.error = false
        }
      }
    },
    async onSignIn () {
      this.onPassword()
      this.isDisableLogin = true
      this.onClickLongin = true
      if (!this.error || this.Networkdifference) {
        sessionStorage.setItem('localToken', new Date().valueOf() + 1800000)
        const stamp = await this.$http.get('/GetLoginStamp').catch((e) => {
          this.error = true
          this.errorType = this.$t('Network delay, please try again.')
          this.Networkdifference = true
          this.onClickLongin = false
          this.isDisableLogin = false
        })
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC51ywBVBF899Rt6brFw1x4jM8b
  /VzqEq+sqK2m1CYPZJEJuHvJWeNjksZLSf9olOU1cu48dIdVNHUGa0vVZfTggP0d
  GeCtKDbLiwzM0jEBy7kbPhDT1wCB/nZCY1hxWBhd7o3vnJX8pGsEvytaw+nSVkLm
  xHsnQpbgspUG8cMEmwIDAQAB
  -----END PUBLIC KEY-----`)
        const encrypted = encrypt.encrypt(stamp.data + this.password)
        try {
          let result = await this.$http.post('/Login', {
            loginstamp: stamp.data,
            username: this.emailValue,
            password: encrypted
          })
          console.log(result.data)
          switch (result.data.code) {
            case 0:
              this.$store.commit(Mutations.login, {type: true})
              this.userID = result.data
              let tokenDate = new Date().valueOf()
              sessionStorage.setItem('tokenDate', tokenDate)
              sessionStorage.setItem('Email', this.emailValue)
              setCookieArray('name', this.emailValue, 7)
              sessionStorage.setItem('userID', this.userID.data)
              this.$router.push({ path: `/User/${this.userID.data}` })
              break
            case -1:
              this.error = true
              this.errorType = this.$t('Incomplete parameters.')
              break
            case -2:
              this.error = true
              this.errorType = this.$t('Username does not exist.')
              break
            case -3:
              this.error = true
              this.errorType = this.$t('Incorrect username or password.')
              break
            case -4:
              this.error = true
              this.errorType = this.$t('unexpected error.')
              break
            case -5:
              this.error = true
              this.errorType = this.$t('Incorrect username or password.')
              break
            case -7:
              this.error = true
              this.errorType = this.$t('Current account is not activated.')
              break
            default:
              this.error = true
              this.errorType = this.$t('unexpected error.')
          }
          this.onClickLongin = false
          this.isDisableLogin = false
        } catch (error) {
          console.log(error)
          this.error = true
          this.errorType = this.$t('Network delay, please try again.')
          this.Networkdifference = true
          this.isDisableLogin = false
          this.onClickLongin = false
        }
      }
    },
    filterAccount (newValue) {
      let datas = this.cookiesList
      let filter = newValue
      if (filter.length !== 0) {
        filter = filter.toLowerCase()
        datas = datas.filter((val) => {
          let included = false
          included = included || [val.name].some(valText => valText && valText.toLowerCase().includes(filter))
          return included
        })
      }
      this.showCookiesList = datas
      this.$nextTick(() => {
        this.showCookies = true
      })
    },
    onRegister () {
      this.$router.push({name: 'Register'})
    }
  },
  watch: {
    emailValue: function (newValue) {
      this.showCookies = false
      this.filterAccount(newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-center{
    width: 63%;
    background-color: #ffffff;
    border-radius: 20px;
  }
  .login-footer{
    font-family: 'Nunito-Light';
    font-size: 14px;
    color: #ffffff;
  }
  .login-left-bg{
    width:45%;
    height:100%;
    border-top-left-radius:20px;
    border-bottom-left-radius:20px;
    background-color:#edf5f2;
    img{
        width: auto;height: auto;max-width: 100%;max-height: 100%;
      }
  }
  .login-right{
    width:55%;
    height:100%;
    padding:20px;
    box-sizing:border-box;
    .login-right-welcome{
      margin-top:70px;
      font-size: 36px;
      color: #404040;
    }
    .sign-btn{
      margin-top:100px;
      margin-bottom: 30px;
    }
    .no-account{
      margin-top:20px;
      font-size:16px;
      color:#888;
      span{
        color:#2bcf88;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
@media (min-width: 1024px){
  .login-center{
    // height: 78%;
  }
  .full_content {
    height: 100%;
  }
}
@media (max-width: 1024px){
  .login-center{
    // height: 66%;
    margin-top: 100px;
  }
  .login-left-bg {
    display: none;
  }
  .login-right{
    width: 100%;
    .login-right-welcome{
      font-size: 30px;
      margin-top:8%;
    }
    .sign-btn{
      margin-top:80px;
    }
    .no-account{
      margin-top:30px;
    }
  }
}
@media (max-width: 768px){
  .login-center{
    // height: 66%;
    width: 80%;
  }
}
@media (max-width: 540px){
  .login-center{
    // height: 100%;
    width: 90%;
    margin-top: 100px;
  }
}
@media (max-width: 320px){
  .login-right{
    width: 100%;
    .login-right-welcome{
      font-size: 20px;
    }
    .no-account{
      margin-top:30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue